export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-180x180-127e5e5d1b2a2e78d5b43f0f50f4a229.png";